import { Link } from 'react-router-dom';
import SmashSpinner from '../../../components/SmashSpinner/SmashSpinner';
import SmashTable from '../../../components/SmashTable/SmashTable';
import { TableActionItem } from '../../../components/SmashTable/SmashTableAction';
import { TableHeaders } from '../../../components/SmashTable/SmashTableHead';
import { useDomains } from '../hooks/useDomains';
import ConfirmDeleteModal from './ConfirmDeleteDomainModal';

const ListDomain = () => {
    const [isLoading, domains] = useDomains();

    const headers: TableHeaders[] = [{
        label: 'Domain',
        accessor: 'domain',
        sortable: false,
    }, {
        label: 'Team ID',
        accessor: 'id',
        sortable: false,
    }, {
        label: 'Created',
        type: 'date',
        accessor: 'created',
        sortable: true,
        sortbyOrder: "desc"
    }]

    const actions: TableActionItem[] = [{
        name: 'settings',
        url: (item) => "/settings/domains/" + item.id,
        actionComponent: (props) => <span>Settings</span>,
       }, {
        name: 'delete',
        actionComponent: (props) => <ConfirmDeleteModal item={props.item}>Delete</ConfirmDeleteModal>,
    }]

    if (isLoading) {
        return <SmashSpinner />;
    }

    return (
        <SmashTable loading={isLoading} headers={headers} items={domains} tableActions={actions} textFallback={'No domains'} />
    )
}


export default ListDomain